import React, { useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./HowItWorks.css";

import selfJourneyImg from "../../assets/images/smartmockups_l6bwtrsi 1.png";
import intermediaryImg from "../../assets/images/Group 39476@2x.png";

import mobileCuate from "../../assets/images/Mobilecuate@2x.png";

import writersBlock from "../../assets/images/writers-block-cuate.png";
import group1000000890 from "../../assets/images/Group 1000000890.png";
import devicesCuate from "../../assets/images/devices_cuate.png";

import group1000001030 from "../../assets/images/Group 1000001030@2x.png";
import smartmockups3 from "../../assets/images/smartmockups_l6bwtrsi 3@2x.png";
import group39499 from "../../assets/images/Group 39499@2x.png";

import group1000001032 from "../../assets/images/Group 1000001032@2x.png";
import group39505 from "../../assets/images/Group 39505@2x.png";
import cuate from "../../assets/images/cuate.png";

import horiArrow from "../../assets/images/horiArrow1.png";

/* Intermediary Journey */

import group1000001105 from "../../assets/images/Group 1000001105@2x.png";
import group1000001106 from "../../assets/images/Group 1000001106@2x.png";

import group39493 from "../../assets/images/Group 39493@2x.png";
import group39492 from "../../assets/images/Group 39492@2x.png";

import certiCuate from "../../assets/images/certiCuate@2x.png";
import enterOtpCuate from "../../assets/images/Enter-otp-cuate@2x.png";
import confirmedCuate from "../../assets/images/confirmedCuate@2x.png";

const HowItWorks: React.FC = () => {
  const [activeJourney, setActiveJourney] = useState<
    "self" | "intermediary"
  >("self");

  return (
    <>

<title>How Premium Finance Works at Finsall</title>
<meta
  name="description"
  content="Understand Finsall’s step by step premium financing process that enables customers to convert insurance payments into easy EMIs without collateral."
/>

      <Header />

      <main className="how-it-works-page">

        {/* Top Banner */}

        <section className="how-banner"></section>

        {/* Journey Cards */}

        <section className="journey-section">

          <div className="container">

            <div className="journey-cards">

  {/* Card 1 */}
  <div className="journey-card">

    <div className="journey-image">
      <img
        src={selfJourneyImg}
        alt="Laptop showing customer self service premium financing screen"
      />
    </div>

    <div className="journey-content">

      <h3>
        CUSTOMER SELF SERVICE JOURNEY
      </h3>

      <p>
        Bespoke insurance premium financing solution helps
        customers carry out the process right from the comfort
        of their homes. This can be enabled by an easy API
        integration at the customer check-out page.
      </p>

      <button
        className="journey-btn"
        onClick={() => setActiveJourney("self")}
      >
        View Self Service Workflow
      </button>

    </div>

  </div>

  {/* Card 2 */}
  <div className="journey-card assisted-card">

    <div className="journey-image">
      <img
        src={intermediaryImg}
        alt="mobile app screen for intermediary assisted premium financing"
      />
    </div>

    <div className="journey-content">

      <h3>
        INTERMEDIARY ASSISTED JOURNEY
      </h3>

      <p>
        An assisted journey can be started today itself. Intermediaries can use our App or Web portal to assist customers in their premium financing journey. Quote, customer tracking, application tracking, etc., can be done on the fly.
      </p>

      <button
        className="journey-btn"
        onClick={() => setActiveJourney("intermediary")}
      >
        View Assisted Workflow
      </button>

    </div>

  </div>

</div>

            {/* Tabs */}

    

            <div className="journey-tabs">

              <button
                className={
                  activeJourney === "self"
                    ? "journey-tab active"
                    : "journey-tab"
                }
                onClick={() => setActiveJourney("self")}
              >
                CUSTOMER SELF SERVICE JOURNEY
              </button>

              <button
                className={
                  activeJourney === "intermediary"
                    ? "journey-tab active"
                    : "journey-tab"
                }
                onClick={() => setActiveJourney("intermediary")}
              >
                INTERMEDIARY ASSISTED JOURNEY
              </button>

            </div>

            </div>
    

        </section>
                        {/* Customer Self Journey */}
          <div className="journey-content-section">                      

            {activeJourney === "self" && (
              <>

                <section className="customer-story-section">

                  <div className="customer-story-card">

                    <div className="customer-story-image">

                      <img
  src={mobileCuate}
  alt="illustration of customer thinking about insurance policy"
/>

                    </div>

                    <div className="customer-story-content">

                      <h2>Customer's Self Journey</h2>

                      <p>
                        Aman, 40, has reached an ageing landmark and is
                        looking to plan for his family's well-being. He is
                        looking for health insurance options for his family
                        and selects a 10 L sum assured policy which costs
                        Rs. 40,000.
                      </p>

                    </div>

                  </div>

                </section>

                <section className="workflow-section">

                  <div className="workflow-card">

                    {/* Row 1 */}

                    <div className="workflow-row">

                      <div className="workflow-step">

                       <img
  src={writersBlock}
  alt=""
/>

                        <p>
                          Rs. 40,000 is too much for him to pay upfront as
                          his monthly expenses & EMIs are already lined up.
                        </p>

                      </div>

                      <div className="workflow-arrow">
                        <img src={horiArrow} alt="" />
                      </div>

                      <div className="workflow-step">

                        <img
  src={group1000000890}
  alt=""
/>

                        <p>
                          Aman has already chosen the cover he wants for
                          his family and the limits.
                        </p>

                      </div>

                      <div className="workflow-arrow">
                        <img
  src={horiArrow}
  alt=""
/>
                      </div>

                      <div className="workflow-step">

                        <img
  src={devicesCuate}
  alt=""
/>

                        <p>
                          He is happy to discover Finsall on the check-out
                          page as a premium financing option and starts the
                          process.
                        </p>

                      </div>

                    </div>

                    <div className="workflow-divider">
                      ↓
                    </div>

                    {/* Row 2 */}

                    <div className="workflow-row">

                      <div className="workflow-step">

                        <img
  src={group1000001030}
  alt=""
/>

                        <p>
                          Aman is led to Finsall's page, where most of his
                          data is pre-filled. This starts his paperless
                          process.
                        </p>

                      </div>

                      <div className="workflow-arrow">
                        <img
  src={horiArrow}
  alt=""
/>
                      </div>

                      <div className="workflow-step">

                        <img
  src={smartmockups3}
  alt=""
/>

                        <p>
                          Aman has to then provide his consent for
                          verification and credit assessment. He enters
                          the OTP and clicks next.
                        </p>

                      </div>

                      <div className="workflow-arrow">
                        <img
  src={horiArrow}
  alt=""
/>
                      </div>

                      <div className="workflow-step">

                        <img
  src={group39499}
  alt=""
/>

                        <p>
                          Once verification is completed, Aman is
                          immediately told about his approval.
                        </p>

                      </div>

                    </div>

                    <div className="workflow-divider">
                      ↓
                    </div>
                                        {/* Row 3 */}

                    <div className="workflow-row">

                      <div className="workflow-step">

                        <img
  src={group1000001032}
  alt=""
/>

                        <p>
                          Aman is led to a simple onboarding page, which
                          has a step-by-step process. At this point, Aman
                          finds his Aadhaar Card and completes the eKYC,
                          eSign and eNACH process.
                        </p>

                      </div>

                      <div className="workflow-arrow">
                        <img
  src={horiArrow}
  alt=""
/>
                      </div>

                      <div className="workflow-step">

                        <img
  src={group39505}
  alt=""
/>

                        <p>
                          The application is then checked by Finsall for
                          quality assurance. Once it passes the quality
                          checks, Aman completes the upfront payment and
                          the policy is issued instantly.
                        </p>

                      </div>

                      <div className="workflow-arrow">
                        <img
  src={horiArrow}
  alt=""
/>
                      </div>

                      <div className="workflow-step">

                        <img
  src={cuate}
  alt=""
/>

                        <p>
                          Finsall continues to help Aman with monthly EMI
                          reminders and access points for any of his
                          queries.
                        </p>

                      </div>

                    </div>

                  </div>

                </section>
                

                {/* CTA Section */}

                <section className="journey-cta">

                  <div className="journey-cta-card">

                    <div className="journey-cta-content">

                      <h3>
                        Schedule a Training Session
                      </h3>

                      <p>
                        Please connect with our premium financing
                        specialists
                      </p>

                    </div>

                    <div className="journey-cta-action">

                      <button className="cta-btn"
                      onClick={() =>
              window.location.href = "/contact-us"
            }>
                        Get in Touch
                      </button>

                    </div>

                  </div>

                </section>

              </>
            )}
                        {/* Intermediary Journey */}

            {activeJourney === "intermediary" && (
              <>
                <section className="customer-story-section">

                  <div className="customer-story-card">

                    <div className="customer-story-image2">

                      <img
  src={group1000001105}
  alt="illustration of customer celebrating insurance financing approval"
/>

                    </div>

                    <div className="customer-story-content">

                      <h2>Intermediary Led Journey</h2>

                      <p>
                        Aman, 40, has reached an ageing landmark and is
                        looking to plan for his family's well-being. He is
                        looking for health insurance options for his family
                        and selects a 10 L sum assured policy which costs
                        Rs. 40,000.
                      </p>

                    </div>

                  </div>

                </section>

                <section className="workflow-section">

  <div className="workflow-card">

    {/* Row 1 */}

    <div className="workflow-row">

      <div className="workflow-step">
        <img src={group1000001106} alt="" />

        <p>
          Rs. 40,000 is too much for Aman to pay upfront as
          his monthly expenses and EMIs are already lined up.
        </p>
      </div>

      <div className="workflow-arrow">
        <img src={horiArrow} alt="" />
      </div>

      <div className="workflow-step">
        <img src={group39493} alt="" />

        <p>
          Aman reaches out to an intermediary who explains
          the premium financing option offered by Finsall.
        </p>
      </div>

      <div className="workflow-arrow">
        <img src={horiArrow} alt="" />
      </div>

      <div className="workflow-step">
        <img src={group39492} alt="" />

        <p>
          The intermediary calculates the upfront payment
          and EMI amount using Finsall.
        </p>
      </div>

    </div>

    <div className="workflow-divider">↓</div>

    {/* Row 2 */}

    <div className="workflow-row">

      <div className="workflow-step">
        <img src={certiCuate} alt="" />

        <p>
          Customer details are entered and the application
          is started on the Finsall platform.
        </p>
      </div>

      <div className="workflow-arrow">
        <img src={horiArrow} alt="" />
      </div>

      <div className="workflow-step">
        <img src={enterOtpCuate} alt="" />

        <p>
          Aman receives an OTP and completes verification.
        </p>
      </div>

      <div className="workflow-arrow">
        <img src={horiArrow} alt="" />
      </div>

      <div className="workflow-step">
        <img src={group39499} alt="" />

        <p>
          Approval is communicated and details are confirmed.
        </p>
      </div>

    </div>

    <div className="workflow-divider">↓</div>

    {/* Row 3 */}

    <div className="workflow-row">

      <div className="workflow-step">
        <img src={confirmedCuate} alt="" />

        <p>
          Aman completes eKYC, eSign and eNACH.
        </p>
      </div>

      <div className="workflow-arrow">
        <img src={horiArrow} alt="" />
      </div>

      <div className="workflow-step">
        <img src={group39505} alt="" />

        <p>
          Quality checks are completed and policy issuance
          is processed.
        </p>
      </div>

      <div className="workflow-arrow">
        <img src={horiArrow} alt="" />
      </div>

      <div className="workflow-step">
        <img src={cuate} alt="" />

        <p>
          Finsall continues supporting the customer with
          reminders and assistance.
        </p>
      </div>

    </div>

  </div>

</section>

                <section className="journey-cta">

                  <div className="journey-cta-card">

                    <div className="journey-cta-content">

                      <h3>
                        Schedule a Training Session
                      </h3>

                      <p>
                        Please connect with our premium financing
                        specialists
                      </p>

                    </div>

                    <div className="journey-cta-action">

                      <button className="cta-btn"
                      onClick={() =>
              window.location.href = "/contact-us"
            }>
                        Get in Touch
                      </button>

                    </div>

                  </div>

                </section>

              </>
            )}

          </div>  

      </main>

      <Footer />

    </>
  );
};

export default HowItWorks;